
const viteImportAnalysisModulePrefix = '/@id/';
const tag = 'external:';
const prefix = `${viteImportAnalysisModulePrefix}${tag}`;

export { viteImportAnalysisModulePrefix, tag, prefix };
